import css from './progress.module.css'

export const ProgressBar = ({ max, label, value }: { max: number; value: number; label: any }) => {
  return (
    <div className={css.container}>
      <label for="scandit-progress">{label}</label>
      <progress id="scandit-progress" max={max} value={value}>
        {value}%
      </progress>
    </div>
  )
}
